import { queryOptions } from '@tanstack/react-query';
import * as ratingsApi from '../endpoints/ratings';
import { RatingWire } from '../schemas/rating';

/**
 * Query keys for ratings
 */
export const RATINGS_QUERY_KEYS = {
  all: ['ratings'] as const,
  list: () => [...RATINGS_QUERY_KEYS.all, 'list'] as const,
} as const;

/**
 * Domain-oriented query options for rating operations
 * Provides reusable queryOptions that can be used in hooks or prefetching
 */

/**
 * Query options for fetching all menu item ratings
 *
 * @returns Query options for the ratings list
 *
 * @example
 * ```typescript
 * const options = ratingsListQueryOptions();
 * const { data: ratings } = useQuery(options);
 * ```
 */
export const ratingsListQueryOptions = () =>
  queryOptions({
    queryKey: RATINGS_QUERY_KEYS.list(),
    queryFn: async (): Promise<RatingWire[]> => {
      return ratingsApi.getRatings();
    },
    staleTime: 1000 * 60 * 60, // 1 hour (ratings rarely change)
    gcTime: 1000 * 60 * 120, // 2 hours
    meta: {
      persist: false, // No persisted cache: auth-required data
    },
  });
